import * as React from 'react';
import styled from 'styled-components';

import Slider from "rc-slider";
import "../../rc-slider.css";

interface IProps {
    inputRef: React.RefObject<HTMLDivElement>,
    onAnswerChange: (questionId: number, answer: string, itemIndex?: number) => void,
    question: string,
    questionId: number,
    refProp?: React.RefObject<HTMLDivElement>,
    checkedItem?: number,
    choices: string[]
};

const QuestionContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: end;
    align-items: stretch;
    padding: 3px 12px;
    & > label > div {
        margin: 3px 6px;
    }
    &:nth-child(even) {
        background: #003087;
    }
`;

const AnswerContainer = styled.div`
    height: 100px;
    font-size: 20px;
    width: 80%;
    margin: auto;
    display: flex;
    flex-direction: row;
    align-content: space-between;
    flex: 1 1 auto;
    & label {
        flex: 1 1 auto;
        margin: 0 6px;
    }
    & label > div > div {
        margin: 3px;
    }
`;

const Question = styled.p`
    flex: 1 1 auto;
    font-size: 1em;
    margin: 20px;
    text-align: center;
`;

const Mark = styled.i`
    width: 50px;
    margin: auto;
    margin-top: 5px;
    text-align: center;
    font-style: normal;
    display: inline-block;
`;

const DialogScaleMultipleChoiceQuestion = (props: IProps) => {
    const { inputRef, onAnswerChange, checkedItem, choices, question, questionId, refProp } = props;

    const onSetAnswer = (e: number | number[]) => {
        if (Array.isArray(e)) {
            onAnswerChange(questionId, choices[e[0]], e[0]);
        }
        else {
            onAnswerChange(questionId, choices[e], e);
        }
    }

    const marks = {
        0: <Mark>1<br />Totally dissatisfied</Mark>,
        1: <Mark>2</Mark>,
        2: <Mark>3</Mark>,
        3: <Mark>4</Mark>,
        4: <Mark>5</Mark>,
        5: <Mark>6</Mark>,
        6: <Mark>7<br />Totally satisfied</Mark>,
    };

    const value = checkedItem !== -1 ? checkedItem : 3;

    return <QuestionContainer ref={refProp}>
        <Question>{question}</Question>
        <AnswerContainer>
            <Slider
                ref={inputRef}
                min={0}
                max={6}
                value={value}
                onChange={onSetAnswer}
                trackStyle={{
                    background: "none"
                }}
                marks={marks}
            />
        </AnswerContainer>
    </QuestionContainer>;
};

export default DialogScaleMultipleChoiceQuestion;




// WEBPACK FOOTER //
// ./src/Forms/dialog/DialogScaleMultipleChoiceQuestion.tsx